export const PUBLISHER_VOLUME_FACTOR = 3;

export const MINIMUM_VOLUME_THRESHOLD = 0.02;
